const APP_EDITIONS = ['试用版', '基础版', '高级版'];
const EDITION_PRICE = {
  0: 0,
  1: 360,
  2: 980
};

export {APP_EDITIONS, EDITION_PRICE}



// WEBPACK FOOTER //
// ./src/constants/constants.js